import React from 'react';
import { Autocomplete, TextField, Checkbox, FormControl, FormHelperText, InputAdornment, Chip } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CropSquare from '@mui/icons-material/CropSquare';
import isEmpty from 'lodash/isEmpty';
import CloseIcon from '@mui/icons-material/Close';
import { bool, func, string, array, oneOfType } from 'prop-types';

const DropdownField = props => {
    const {
        options = [],
        className,
        size = 'large',
        label,
        description,
        placeholder,
        multiple = false,
        required = false,
        disabled = false,
        error = false,
        onChange,
        value = '',
        onBlur,
        disableClearable = true,
    } = props;
    const renderOption = (renderProps, option, state) => (
        <li {...renderProps}>
            <Checkbox icon={<CropSquare fontSize="medium" />} defaultChecked={state.selected} size="small" />
            {option}
        </li>
    );
    const renderTags = (tagValue, getTagProps) =>
        tagValue.map((option, index) => (
            <Chip
                key={option}
                label={option}
                {...getTagProps({ index })}
                color="cerulean"
                deleteIcon={<CloseIcon fontSize="small" />}
            />
        ));

    const handleChange = (e, selectedValue) => {
        if (onChange) {
            onChange(selectedValue);
        }
    };

    return (
        <FormControl className="dropdownFormControl" size={size} disabled={disabled} error={error} onBlur={onBlur}>
            <Autocomplete
                value={isEmpty(value) ? '' : value}
                className={className}
                onChange={handleChange}
                size={size}
                disableClearable={disableClearable}
                options={options}
                required={required}
                multiple={multiple}
                disabled={disabled}
                renderOption={multiple ? renderOption : null}
                renderTags={multiple ? renderTags : null}
                renderInput={params => (
                    <TextField
                        {...params}
                        placeholder={placeholder}
                        required={required}
                        label={label}
                        error={error}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: <>{params.InputProps.startAdornment}</>,
                            endAdornment: (
                                <>
                                    <InputAdornment position="end">
                                        {error && <ErrorOutlineIcon color="error" />}
                                    </InputAdornment>
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
            <FormHelperText disabled={disabled}>{description}</FormHelperText>
        </FormControl>
    );
};

DropdownField.propTypes = {
    options: oneOfType([string, array]),
    className: string,
    size: string,
    label: string,
    description: string,
    placeholder: string,
    multiple: bool,
    required: bool,
    disabled: bool,
    disableClearable: bool,
    error: bool,
    value: string,
    setOptions: func,
    onBlur: func,
};

DropdownField.defaultProps = {
    options: [],
    className: '',
    size: 'large',
    label: '',
    disableClearable: true,
    description: '',
    placeholder: '',
    multiple: false,
    required: false,
    disabled: false,
    value: '',
    error: false,

    setOptions: () => {},
    onBlur: () => {},
};

export default DropdownField;
